import {Expression, ExpressionElement} from '@packages/systems/wfdl-ast';
import {isComponentOnlyDropTarget} from '@packages/utilities/elementTypeUtils';
import {findFurthestAncestor} from '@packages/utilities/core-elements';

export function isComponentOnlyPageSlotDescendant(
  rootExpr: Expression,
  element: ExpressionElement
): boolean {
  return Boolean(
    findFurthestAncestor(rootExpr, element, isComponentOnlyDropTarget)
  );
}
